import { useSplitTreatments } from '@splitsoftware/splitio-react';

const BYPASS_SPLIT = import.meta.env.VITE_BYPASS_SPLIT === 'true';

let useFeatureFlagSplit: (a: string, b?: boolean, c?: boolean) => boolean | string;

if (BYPASS_SPLIT) {
  useFeatureFlagSplit = (): boolean => {
    return false;
  };
} else {
  useFeatureFlagSplit = (
    featureFlag: string,
    isMultivariate?: boolean,
    dynamicConfig?: boolean
  ): boolean | string => {
    // evaluate feature flags with the `useSplitTreatments` hook
    const { treatments, isReady } = useSplitTreatments({ names: [featureFlag] });

    if (!isReady) {
      return false;
    }
    // Default type is boolean
    // Multivariate type means it can have multiple values
    // Dynamic config means it can have a JSON object as a value -- Added this to handle special characters inside FF values
    const { treatment } = treatments[featureFlag];
    if (dynamicConfig) {
      let parsedTreatment;
      try {
        parsedTreatment = JSON.parse(treatments[featureFlag].config || '{}');
        return parsedTreatment?.value?.toString() || '';
      } catch (e) {
        console.error('Error parsing treatment config:', e);
        return '';
      }
    } else if (isMultivariate) {
      return treatment;
    } else {
      return treatment === 'on';
    }
  };
}

export { useFeatureFlagSplit };
